/** Tiny, color-inheriting trademark superscript.
 *
 *  - Renders as "TM" inside a <sup>, so it sits above the baseline and stays
 *    much smaller than surrounding text (~0.5em).
 *  - By default it inherits the parent's text color via `currentColor`, so it
 *    automatically matches whatever word it sits next to.
 *  - Explicitly overrides `-webkit-text-fill-color` in case the parent uses a
 *    gradient text (`text-gradient-gold`) that would otherwise make the sup
 *    invisible. For those cases, pass a `color` prop with the desired hex.
 */
export const TM = ({ color, className = "" }) => (
  <sup
    aria-hidden
    className={`text-[0.32em] tracking-normal ml-[0.1em] font-medium align-super opacity-90 ${className}`}
    style={{
      color: color || "currentColor",
      WebkitTextFillColor: color || "currentColor",
      background: "none",
      WebkitBackgroundClip: "border-box",
      lineHeight: 1,
    }}
  >
    TM
  </sup>
);

export default TM;
